import React, {useEffect, useState} from "react";
import { Redirect} from "react-router-dom";
import API from "../../helpers/apiHelpers";
import {RootState, useAppDispatch} from "../../redux/store";
import {Login, BeforeLogin} from "../index";
import {getUserProfile} from "../../redux/userProfile/userProfile.actions";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";
import {clearPetStore} from "../../redux/pets/pets.reducers";
const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const IsLoggedInCheck: React.FC = () => {
    const dispatch = useAppDispatch();
    const query = useQuery();
    const path = useLocation();
    const isLogin = query.get("login");
    const branding = useSelector((state: RootState) => state?.branding);
    const isLeave = useSelector((state: RootState) => state?.common?.isLeaveFormFilled);
    const [isConfirmed, setIsConfirmed] = useState(undefined);
    const [login, setLogin] = useState ( isLogin?.length ? true : false);

    useEffect(() => {
        if (isLogin?.length) setLogin(true);
    }, [isLogin]);
    useEffect(() => {
        dispatch(clearPetStore());
        const auth = JSON.parse(localStorage.getItem("auth"));
        if(auth) {
            dispatch(getUserProfile({userId: auth.userId}))
                .then(()=> setIsConfirmed(true))
                .catch((err) => {
                    if (err?.status === 403) {
                        setIsConfirmed(false);
                    }});
        }
    }, []);

    return(
        <>
            {API.isLoggedIn && isConfirmed ? <Redirect to="/"/> :
                branding.partnerPreferencesOn && !login && isLeave === null ?  <Redirect to={{pathname:"/welcome", state: path.state}}/>
                    : <Login/>}
        </>
    );
};

export default IsLoggedInCheck;
